module.exports = __webpack_public_path__ + "static/media/icon_discount.89468395.svg";